"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilterName = getFilterName;
exports.setQueryParams = setQueryParams;
exports.updateQueryFilters = updateQueryFilters;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _qs = _interopRequireDefault(require("qs"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function updateQueryFilters(newFilter) {
  var _queryParameters$filt, _queryParameters$filt2;

  var searchQuery = window.location.search;

  var queryParameters = _qs.default.parse(searchQuery, {
    ignoreQueryPrefix: true
  });

  var newFilterKey = Object.keys(newFilter)[0];
  queryParameters === null || queryParameters === void 0 ? true : delete queryParameters.page;
  queryParameters === null || queryParameters === void 0 ? true : (_queryParameters$filt = queryParameters.filters) === null || _queryParameters$filt === void 0 ? true : delete _queryParameters$filt[newFilterKey];
  var newQuery = {
    filters: (_queryParameters$filt2 = queryParameters === null || queryParameters === void 0 ? void 0 : queryParameters.filters) !== null && _queryParameters$filt2 !== void 0 ? _queryParameters$filt2 : {}
  };

  if (newFilter[newFilterKey] !== null) {
    var _queryParameters$filt3;

    newQuery = {
      filters: _objectSpread(_objectSpread({}, (_queryParameters$filt3 = queryParameters === null || queryParameters === void 0 ? void 0 : queryParameters.filters) !== null && _queryParameters$filt3 !== void 0 ? _queryParameters$filt3 : {}), newFilter)
    };
  }

  if (newFilterKey === 'productAreaSectionId' && newFilter[newFilterKey] !== null) {
    delete newQuery.filters.productArea;
  }

  if (newFilterKey === 'productArea' && newFilter[newFilterKey] !== null) {
    delete newQuery.filters.productAreaSectionId;
  }

  window.history.pushState('', '', "?".concat(_qs.default.stringify(_objectSpread(_objectSpread({}, queryParameters), newQuery))));
}

function setQueryParams(newQuery) {
  var searchQuery = window.location.search;

  var queryParameters = _qs.default.parse(searchQuery, {
    ignoreQueryPrefix: true
  });

  var combinedQuery = _objectSpread(_objectSpread({}, queryParameters), newQuery);

  if ((combinedQuery === null || combinedQuery === void 0 ? void 0 : combinedQuery.page) === 1) {
    combinedQuery === null || combinedQuery === void 0 ? true : delete combinedQuery.page;
  }

  window.history.pushState('', '', "?".concat(_qs.default.stringify(combinedQuery)));
}

function getFilterName(filterKey, filterValue, categoryMapping) {
  if (filterKey === 'category') {
    return categoryMapping[filterValue];
  }

  return filterValue;
}